export const ColumnIds = {
  name: 'name',
  rank: 'rank',
  displayOrder: 'displayOrder',
  code: 'code',
} as const;
